import PropTypes from 'prop-types';
import { BsPersonBadge, BsPersonFill } from 'react-icons/bs';

import SectionCard from '#globalComponents/Card/SectionCard';
import useContactRoles from '#globalHooks/useContactRoles';

const formatDate = (value) => (value ? new Date(value).toLocaleDateString('de-DE') : null);

const CompanyDirectors = ({ directors }) => {
	const { roleLabel } = useContactRoles();
	return (
		<SectionCard title="Geschäftsführung" icon={BsPersonBadge} bodyClassName="p-0">
			<ul className="divide-y divide-bgBase-500">
				{directors.map((director) => {
					const startDate = formatDate(director.startDate);
					const endDate = formatDate(director.endDate);

					return (
						<li key={director.id} className="flex items-center gap-3 px-4 py-3">
							<div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-bgBase-400 text-bgBase-800">
								<BsPersonFill className="h-4 w-4" />
							</div>
							<div className="min-w-0 flex-1">
								<div className="text-sm font-medium text-text">{director.fullname}</div>
								<div className="text-xs text-bgBase-800">
									{roleLabel(director.companyRole) || 'Unbekannt'}
									{startDate && ` · seit ${startDate}`}
									{endDate && ` · bis ${endDate}`}
								</div>
							</div>
						</li>
					);
				})}
			</ul>
		</SectionCard>
	);
};

CompanyDirectors.propTypes = {
	directors: PropTypes.array.isRequired,
};

export default CompanyDirectors;
